import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import TextNowButton from "./components/TextNowButton";
import SurfingLogo from "./components/SurfingLogo";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import ServicesOverview from "./pages/ServicesOverview";
import Gallery from "./pages/Gallery";
import AboutUs from "./pages/AboutUs";
import BookToday from "./pages/BookToday";
import Waiver from "./pages/Waiver";

const SERVICE_SLUGS = [
  "private-lessons",
  "hotel-lessons",
  "semi-private",
  "group-lessons",
  "kids-surf-camps",
  "kids-fishing-charter",
  "san-diego-bay-fishing",
  "offshore-outerbanks",
  "coronado-islands",
  "whale-dolphin-watching",
  "sunset-cruises",
  "paddle-boarding",
  "catalina-island-tours",
  "nicaragua",
];

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  React.useEffect(() => {
    const removeBadge = () => {
      const badge = document.getElementById("emergent-badge");
      if (badge) badge.remove();
    };
    removeBadge();
    const obs = new MutationObserver(removeBadge);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main className="min-h-screen">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/surf-lessons" element={<ServicesOverview category="surf" />} />
              <Route path="/surf-lessons/encinitas" element={<ServicesOverview category="surf" city="encinitas" />} />
              <Route path="/surf-lessons/san-diego" element={<ServicesOverview category="surf" city="san-diego" />} />
              <Route path="/surf-lessons/so-cal" element={<ServicesOverview category="surf" city="so-cal" />} />
              <Route path="/fishing-trips" element={<ServicesOverview category="fish" />} />
              <Route path="/fishing-trips/encinitas" element={<ServicesOverview category="fish" city="encinitas" />} />
              <Route path="/fishing-trips/san-diego" element={<ServicesOverview category="fish" city="san-diego" />} />
              <Route path="/fishing-trips/so-cal" element={<ServicesOverview category="fish" city="so-cal" />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/book-today" element={<BookToday />} />
              <Route path="/waiver" element={<Waiver />} />
              {SERVICE_SLUGS.map((slug) => (
                <Route key={slug} path={`/${slug}`} element={<ServicePageWrapper slug={slug} />} />
              ))}
            </Routes>
          </main>
          <Footer />
          <SurfingLogo />
          <TextNowButton />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

function ServicePageWrapper({ slug }) {
  // re-render on slug change
  return <ServicePage key={slug} slug={slug} />;
}

export default App;
